import { useMutation } from '@tanstack/react-query'
import { getApiClient, useAppStore } from '~/stores'

type UpdateUserProfileParams = {
  onSuccess?: () => void
  onError?: () => void
}

const useUpdateUserProfile = ({ onSuccess, onError }: UpdateUserProfileParams) => {
  const setCurrentUser = useAppStore((s) => s.setCurrentUser)

  return useMutation({
    mutationFn: getApiClient().updateAccount,
    onSuccess: async ({ account: updatedUser }) => {
      setCurrentUser(updatedUser)
      onSuccess?.()
    },
    onError: (error) => {
      onError?.()
      console.error('Error updating profile', error)
    },
  })
}

export { useUpdateUserProfile }
